import { Icon } from '@iconify/react/dist/iconify.js';
import { Breadcrumbs } from '@mui/material';
import { FC, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import Link from './Link';
import { capitalize } from '@ajorquera/libs/utils';

interface Props {}

const getCrumbLinks = (path: string) => {
  return path
    .split('/')
    .map((singlePath) => {
      const indexOf = path.indexOf(path) + singlePath.length + 1;

      if (indexOf === 0) return path;

      return path.substring(indexOf);
    })
    .filter(Boolean);
};

const PageCrumbs: FC<Props> = () => {
  const location = useLocation();

  const paths = useMemo(() => getCrumbLinks(location.pathname), [location]);

  return (
    <Breadcrumbs separator={<Icon icon="stash:angle-right" />}>
      {paths.map((path) => (
        <Link to={`/${path}`}>{capitalize(path)}</Link>
      ))}
    </Breadcrumbs>
  );
};

export default PageCrumbs;
